import t from "@ext/localization/locale/translate";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

interface HTMLActionsProps {
	openEditor: () => void;
}

const HTMLActions = ({ openEditor }: HTMLActionsProps) => {
	const tooltip = t("edit2");

	return (
		<GlassToolbarButton aria-label={tooltip} onClick={openEditor} tooltipText={tooltip}>
			<GlassToolbarIcon icon="pencil" />
		</GlassToolbarButton>
	);
};

export default HTMLActions;
